import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Toggle from 'material-ui/Toggle';

var UNITS = ['days', 'weeks', 'months', 'years'];

var NeglectWarnings = function (props) {
  var config = props.config;
  var onChange = props.onChange;
  var errors = props.errors || {};
  var t = useTranslation().t;
  var neglect = config.neglectWarnings;
  var isEnabled = !!neglect;

  var handleToggle = function () {
    if (isEnabled) {
      onChange('neglectWarnings', null);
    } else {
      onChange('neglectWarnings', { every: 1, unit: 'days' });
    }
  };

  var handleEveryChange = function (e) {
    if (e.target.value === '') {
      onChange('neglectWarnings', Object.assign({}, neglect, { every: null }));
      return;
    }
    var val = parseInt(e.target.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    onChange('neglectWarnings', Object.assign({}, neglect, { every: val }));
  };

  var handleUnitChange = function (e) {
    onChange('neglectWarnings', Object.assign({}, neglect, { unit: e.target.value }));
  };

  return (
    <div className="inspect-section-neglect-warnings">
      <div className="inspect-settings-content-header">
        <h3 className="inspect-settings-content-title">{t('inspect:sectionNeglectWarnings')}</h3>
        <p className="inspect-settings-content-description">{t('inspect:neglectWarningsDescription')}</p>
      </div>

      <div className="inspect-neglect-toggle">
        <Toggle
          toggled={isEnabled}
          onToggle={handleToggle}
          label={isEnabled ? t('inspect:neglectEnabled') : t('inspect:neglectDisabled')}
          labelPosition="right"
          trackStyle={{ backgroundColor: 'var(--sl-grey-300)' }}
          thumbStyle={{ backgroundColor: 'var(--sl-grey-400)' }}
          trackSwitchedStyle={{ backgroundColor: 'var(--sl-primary)' }}
          thumbSwitchedStyle={{ backgroundColor: 'var(--sl-white)' }}
        />
      </div>

      {isEnabled && (
        <div className="inspect-neglect-period">
          <label className="inspect-recurrence-label">{t('inspect:neglectPeriodLabel')}</label>
          <div className="inspect-recurrence-period">
            <span className="inspect-recurrence-every-label">{t('inspect:neglectFlagAfter')}</span>
            <input
              type="number"
              className={'inspect-recurrence-number' + (errors.neglectWarningsPeriodInterval ? ' has-error' : '')}
              value={neglect.every === null || neglect.every === undefined ? '' : neglect.every}
              min="1"
              onChange={handleEveryChange}
            />
            <select
              className={'inspect-recurrence-select' + (errors.neglectWarningsPeriodUnit ? ' has-error' : '')}
              value={neglect.unit || 'days'}
              onChange={handleUnitChange}
            >
              {UNITS.map(function (u) {
                return (
                  <option key={u} value={u}>
                    {t('inspect:unit_' + u)}
                  </option>
                );
              })}
            </select>
          </div>
          {errors.neglectWarningsPeriodInterval && (
            <div className="slate-text-input-error">{errors.neglectWarningsPeriodInterval}</div>
          )}
          {errors.neglectWarningsPeriodUnit && (
            <div className="slate-text-input-error">{errors.neglectWarningsPeriodUnit}</div>
          )}
        </div>
      )}
    </div>
  );
};

NeglectWarnings.propTypes = {
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NeglectWarnings;
